import React, { forwardRef, useLayoutEffect } from 'react';
import * as RadixSlider from '@radix-ui/react-slider';
import classNames from 'classnames';

import styles from './Slider.module.scss';

export interface ISliderProps extends RadixSlider.SliderProps {
    error?: boolean;
}

export const Slider = forwardRef<HTMLDivElement, ISliderProps>(
    ({ className, error, onValueChange, value: valueControlled, ...props }, ref) => {
        // Slider is controlled from inside so we can use on commit or on change mode
        // Without this, onValueCommit would not work if value is controlled from outside
        const [value, setValue] = React.useState<number[]>(
            valueControlled || props.defaultValue || (props.min && [props.min]) || [0],
        );

        useLayoutEffect(() => {
            if (valueControlled) {
                setValue(valueControlled);
            }
        }, [valueControlled]);

        return (
            <div className={styles.wrapper}>
                <RadixSlider.Root
                    value={value}
                    onValueChange={(value) => {
                        setValue(value);
                        onValueChange?.(value);
                    }}
                    ref={ref}
                    data-error={!!error}
                    className={classNames(styles.root, className)}
                    {...props}
                >
                    <RadixSlider.Track className={styles.track}>
                        <RadixSlider.Range className={styles.range} />
                    </RadixSlider.Track>
                    <RadixSlider.Thumb className={styles.thumb} />
                    <RadixSlider.Thumb className={styles.thumb} />
                </RadixSlider.Root>
            </div>
        );
    },
);
